import { render, staticRenderFns } from "./VacancyCardCms.vue?vue&type=template&id=07899bd6&scoped=true&"
import script from "./VacancyCardCms.vue?vue&type=script&lang=js&"
export * from "./VacancyCardCms.vue?vue&type=script&lang=js&"
import style0 from "./VacancyCardCms.vue?vue&type=style&index=0&id=07899bd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07899bd6",
  null
  
)

export default component.exports